import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { getWindow } from '../../../utils/general';
import '../../../styles/order-details.scss';
export var HomeDepotProtectionPlan = function (props) {
    var omsId = props.omsId, originalUnitPrice = props.originalUnitPrice, originalOrderedQuantity = props.originalOrderedQuantity;
    var handleAddProtectionPlan = function () {
        var _a;
        var otherItems = [];
        var addedItem = [];
        if (!omsId) {
            otherItems.push("".concat(omsId, "_").concat(Math.floor(originalUnitPrice !== null && originalUnitPrice !== void 0 ? originalUnitPrice : 0), "_").concat(originalOrderedQuantity));
        }
        else {
            addedItem.push("".concat(omsId, "_").concat(Math.floor(originalUnitPrice !== null && originalUnitPrice !== void 0 ? originalUnitPrice : 0), "_").concat(originalOrderedQuantity));
        }
        var cartReqParams = {
            destination: 'add-protection-plan',
            addedItem: addedItem.join(','),
            otherItems: otherItems.join(','),
            hdppCallFromDrawer: true,
        };
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.LIFE_CYCLE_EVENT_BUS.trigger('cart.addHDPP', {
            cartReqParams: cartReqParams,
        });
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-space-y-4 sui-my-4 sui-w-full card-fix" },
        React.createElement(Button, { variant: "secondary", onClick: handleAddProtectionPlan }, "Add Protection Plan")));
};
export default HomeDepotProtectionPlan;
